import { createContext, useContext } from "react";

// NOTE: This used to be a full server-side iframe proxy viewer that modified
// third-party websites. That feature has been removed. Links now simply open
// in a new tab — the standard, respectful behaviour for cross-origin content.

const ViewerContext = createContext({
  open: (url) => {
    if (!url) return;
    try {
      window.open(url, "_blank", "noopener,noreferrer");
    } catch {}
  },
  close: () => {},
});

export function useSiteViewer() {
  return useContext(ViewerContext);
}

export function SiteViewerProvider({ children }) {
  return <>{children}</>;
}
